
  import RuleNav from '~/components/about/rule-nav.vue'
  export default {
    //  内容管理规范页面
    name: 'Enveloperule',
    components: { RuleNav },
    layout: 'template-page',
    head() {
      return {
        title: '内容管理规范_问卷网',
      }
    },
  }
